var exports = {
  "kL": "x93eb46d8--0c6008--container",
  "iE": "x93eb46d8--0c6008--wrapper",
  "Sl": "x93eb46d8--0c6008--image",
  "Qs": "x93eb46d8--0c6008--content",
  "Pf": "x93eb46d8--0c6008--label",
  "LP": "x93eb46d8--0c6008--accessory",
};

module.exports = exports;
